import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "MarketingHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "m26.086 17.564-8.14 11.202A2.93 2.93 0 0 1 15.56 30c-.323 0-.643-.051-.95-.151a2.94 2.94 0 0 1-2.057-2.836v-7.059a.78.78 0 0 0-.778-.778H8.33a2.98 2.98 0 0 1-2.65-1.607 2.97 2.97 0 0 1 .206-3.085L13.723 3.28c.764-1.092 2.073-1.537 3.341-1.136s2.086 1.518 2.086 2.846v1.68a1.103 1.103 0 0 1-2.204 0v-1.68a.755.755 0 0 0-.543-.744c-.127-.038-.569-.138-.872.298L7.688 15.748a.74.74 0 0 0-.049.803c.131.261.4.424.691.42h3.443a2.99 2.99 0 0 1 2.984 2.984v7.058c0 .525.411.695.534.74.127.038.562.142.871-.285l8.14-11.201a.75.75 0 0 0 .064-.809.75.75 0 0 0-.696-.426H21.81a3.02 3.02 0 0 1-2.84 1.984 3.031 3.031 0 1 1 .003-6.064 3.04 3.04 0 0 1 2.803 1.877h1.895c1.132 0 2.151.621 2.66 1.626.512 1 .417 2.202-.245 3.11"
    })
  }));
};
MarketingHubIcon.displayName = 'MarketingHubIcon';